import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-warehouse-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-warehouse-dialog.html',
  styleUrl: './confirm-warehouse-dialog.css'
})
export class ConfirmWarehouseDialog {
  constructor(
    public dialogRef: MatDialogRef<ConfirmWarehouseDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      currentWarehouseCode: string;
      currentWarehouseName: string;
      newWarehouseCode: string;
      newWarehouseName: string;
    }
  ) {}

  close(confirm: boolean) {
    this.dialogRef.close(confirm);
  }
}
